import React, { CSSProperties, FC, useCallback, useEffect, useMemo, useState } from 'react'
import { useConfig } from '@revenuewell/logic-config'
import { useProduct} from '@revenuewell/logic-product'
import { HelpContentService } from '../services/help-content-service'
import { HelpContentEntry } from '../types/help-content'
import { Button, Stack } from '@mui/material';
import { HelpArrow, HelpContentItem, HelpContentLink, HelpContentList, HelpTitle, HelpTitleRow } from './styles'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Collapse from '@mui/material/Collapse';
import ArticleIcon from '@mui/icons-material/Article';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import Dialog from '@mui/material/Dialog';
import LaunchIcon from '@mui/icons-material/Launch';
import HelpIcon from '@mui/icons-material/Help';
import Zendesk from "react-zendesk";
import { ZendeskAPI } from 'react-zendesk'

export type HelpContentWidgetProps = {
    app: string
    context: string
}

export type HelpContentEntryProps = {
    entry: HelpContentEntry
    featureSet: Set<string>
}

export type ArrowProps = {
    active: boolean
}

export type HelpLinkProps = {
    type: "video" | "article"
    link: string
    inline?: boolean
}

const ZENDESK_KEY = "9153b77b-f992-411e-9d20-363e84c7e78e";

const HelpLink: FC<HelpLinkProps> = (props: HelpLinkProps) => {
    const [showVideo, setShowVideo] = useState<boolean>(false);

    const LinkDisplay = () => {
        if(props.type == "article")
            return <Button size="small" href={props.link} target="_new" endIcon={<ArticleIcon/>} variant="text">Article</Button>;
        else if(!props.inline)
            return <Button size="small" href={props.link} target="_new" endIcon={<OndemandVideoIcon/>} variant="text">Video</Button>;
        else
            return <Button size="small" endIcon={<OndemandVideoIcon/>} variant="text" onClick={() => setShowVideo(true)}>Video</Button>
    }

    return (
        <>
        <HelpContentLink>
            {LinkDisplay()}
        </HelpContentLink>
        
        </>
    )
}

const HelpContentEntryDisplay: FC<HelpContentEntryProps> = (props: HelpContentEntryProps) => {
    const [active, setActive] = useState<boolean>(false);

    const toggleActive = useCallback(() => {
        setActive(!active);
    }, [active]) 

    if(props.entry.featureFlag && !props.featureSet.has(props.entry.featureFlag.toLowerCase())) return <>{""}</>;

    return (
    <HelpContentItem key={props.entry.title}>
        <HelpTitleRow  onClick={toggleActive}>
            <HelpTitle>
                {props.entry.title}
            </HelpTitle>
            <HelpArrow>{active ? <KeyboardArrowDownIcon/> : <KeyboardArrowRightIcon/>}</HelpArrow>
        </HelpTitleRow>
        <Collapse in={active}>
                {props.entry.videoUrl ? <HelpLink type="video" link={props.entry.videoUrl} inline={props.entry.videoInline}/> : null}
                {props.entry.articleUrl ? <HelpLink type="article" link={props.entry.articleUrl}/> : null}
        </Collapse>
    </HelpContentItem>
    );
}

export const HelpContentWidget: FC<HelpContentWidgetProps> = (props: HelpContentWidgetProps) => {
    const { config } = useConfig();
    //const { availableProducts, loadProducts} = useProduct();
    const [helpContent, setHelpContent] = useState<HelpContentEntry[]>([]);
    const availableProducts = ['Forms2'];
    const featureSet = new Set(availableProducts?.map(p => p.toLowerCase()))
    
    /*useEffect(() => {
        if(!availableProducts?.length)
            loadProducts();
    }, []);*/

    useEffect(() => {
        (async () => {
            const helpServ = HelpContentService.getInstance(config);
            const tmp = await helpServ.getHelpContent(props.app, props.context)
            //console.log("***HELP CONTENT", tmp);
            setHelpContent(tmp);
        })()
    }, [config, props])

    const onLoadZendesk = () => {
        ZendeskAPI("webWidget", "hide")
        ZendeskAPI("webWidget:on", "close", () => { console.log("CLOSEING WEB WIDGET"); ZendeskAPI("webWidget", "hide")})
    }

    const launchHelpCenter = () => {
        ZendeskAPI("webWidget", "show");
        ZendeskAPI("webWidget", "open");
    }

    const zendeskSettings = {
        webWidget: {
            color: {
                theme: "#000",
                header: "#004763",
            },
            helpCenter: {
                searchPlaceholder: {
                '*': 'Search our Help Center',
              },
              filter: {
                category: "6356676449051-Communication-Tools,6356685297051-Operational-Tools,6356712992283-Marketing-Tools"
              }
            },
            chat: { suppress: true },
            position: { horizontal: 'left', vertical: 'bottom' },
            offset: {horizontal: '10px'}
          }
      
    }

    
    return availableProducts ? (
    <div style={{padding: "30px"}}>
    <Zendesk defer zendeskKey={ZENDESK_KEY} {...zendeskSettings} onLoaded={onLoadZendesk}/>
    <HelpContentList>
        {helpContent.map(entry => <HelpContentEntryDisplay entry={entry} featureSet={featureSet} key={entry.title}></HelpContentEntryDisplay>)}
    </HelpContentList>
    <div style={{paddingLeft: "8px", paddingTop: "5px"}}><Button size="small" startIcon={<HelpIcon/>} onClick={launchHelpCenter}>Help</Button></div>
    </div>
    ) : <p>no products</p>;
}  